"use client"

import { useEvmSignFunction } from "../arch/evm/useEvmSignFunction"
import { useEvmSignTypedFunction } from "../arch/evm/useEvmSignTypedFunction"
import { useSvmSignFunction } from "../arch/svm/useSvmSignFunction"
import type { SignFunction, SignTypedFunction } from "../types"
import { useAccount } from "./useAccount"

type UseSignature = {
  sign: SignFunction
  signTyped: SignTypedFunction
}

/**
 * Signature helper function
 * @returns object:
 *  - sign: function that signs a message
 *  - signTyped: function that signs a typed message
 */
export const useSignature = (): UseSignature => {
  const { chainArch } = useAccount()

  const sign = useSignFunction(chainArch)
  const signTyped = useSignTypedFunction(chainArch)

  return {
    sign,
    signTyped,
  }
}

const useSignFunction = (chainArch: "EVM" | "SVM") => {
  const evmSign = useEvmSignFunction()
  const svmSign = useSvmSignFunction()

  switch (chainArch) {
    case "SVM":
      return svmSign
    default:
      return evmSign
  }
}

const useSignTypedFunction = (chainArch: "EVM" | "SVM") => {
  const evmSignTyped = useEvmSignTypedFunction()

  switch (chainArch) {
    default:
      return evmSignTyped
  }
}
